/* eslint-disable */
jQuery(($) => {
  var body          = $('body');
  var $videoModule  = $(".videoBlock");
  var $searchHero   = $(".searchHero");
  var $carousel     = $('.offersCarousel');
  var $services     = $('.popularServices');
  var $info         = $('.infoHubArticles');
  var $toggleMenu   = $('.js-toggle-menu');
  var $insMenu      = $('.js-insurance-menu');
  var $aboutMenu    = $('.js-about-menu');
  var $closeSubmenu = $('.js-close-submenu');
  var $coverTool    = $('.policyCoverTool');

  var isDesktop = window.matchMedia("only screen and (min-width: 1024px)").matches;

	$toggleMenu.on('click', function() {
    body.toggleClass('nav-active');
	});

  $insMenu.on('click', function(e) {
    e.preventDefault();
    body.removeClass('about-menu-active');
    body.toggleClass('ins-menu-active');
	});

  $aboutMenu.on('click', function(e) {
    e.preventDefault();
    body.removeClass('ins-menu-active');
    body.toggleClass('about-menu-active');
	});

  $closeSubmenu.on('click', function(e) {
    e.preventDefault();
    body.removeClass('ins-menu-active');
    body.removeClass('about-menu-active');
	});

  // if ($videoModule) {

  //   $videoModule.each(function() {
  //     var mediaCover = this.querySelector('.mediaCover');
  //     var playAction = this.querySelector('.js-play-video');
  //     var mediaPlayer = this.querySelector('.mediaPlayer');
  //     var player = new Vimeo.Player(mediaPlayer);

  //     playAction.addEventListener("click", function(event) {
  //       event.preventDefault();

  //       this.className = "playVideoTrigger js-play-video mediaPlaying";

  //       if (mediaCover) {
  //         mediaCover.className = "mediaCover mediaPlaying";
  //       }

  //       player.setCurrentTime(0);
  //       player.setVolume(1);
  //       player.play();
  //     }, false);

  //     player.on('ended', function() {

  //       if (mediaCover) {
  //         mediaCover.className = "mediaCover";
  //       }
  //       player.setCurrentTime(0);
  //       player.setVolume(0);
  //     });

  //     player.on('timeupdate', function(data) {
  //       if(data.percent > 0.98) {
  //         player.setVolume(0);
  //         playAction.className = "playVideoTrigger js-play-video";
  //       }
  //     });
  //   });
  // }

  if ($videoModule) {
      $videoModule.each(function() {
        var $playTrigger = $(this).find('.js-play-video');
        var $cover = $(this).find('.mediaCover');
        var $parent = $(this);
        var $media = $(this).find('iframe')[0];

        $playTrigger.on('click', function() {
          $cover.addClass('mediaPlaying');
          $parent.addClass('mediaPlaying');
          $media.src += "&autoplay=1";
        });
      });
    }

  if ($searchHero) {
    var $searchNavItem    = $searchHero.find('__typeSelection label');
    var $searchTabs       = $('.__typeSelection .selectopt');
    var $typeTabs         = $('.__typeSelection');
    var $tab              = $('.__typeTabs .tab');
    var $filterAction     = $searchHero.find('.filterAction');
    var $slug             = $searchHero.find('input[name="service"]:checked').val();

    $(window).on('load', function() {
      var $activeTab = $typeTabs.find('input[name="profile"]:checked');
      var tab_id = '--' + $activeTab.attr('value');

      $('input[name="service"]').removeAttr('checked');
      $("." + tab_id).addClass('--active').find('.--default').attr('checked', true).find('+ label').addClass('--current');
    });

    if (performance.getEntriesByType("navigation")[0].type === 'back_forward') {
      // back or forward button functionality
      location.reload();
    }

    $('input[name="profile"]').change(function(){
      var tab_id = '--' + $(this).attr('value');

      $tab.removeClass('--active');
      $searchTabs.removeAttr('checked');
      $(this).attr('checked', true);
      $('input[name="service"]').removeAttr('checked');
      body.click();

      $("." + tab_id).addClass('--active').find('.--default').attr('checked', true).find('+ label').addClass('--current');
    });

    $('input[name="service"]').change(function() {

      $('.option').removeClass('--current');
      $filterAction.addClass('--ready');
      body.click();

      if( $(this).is(":checked") ){
        $(this).find('+ label').addClass('--current');
        $slug = $(this).val();
      }
    });

    $filterAction.on('click', function() {
      window.location = $slug;
    });
  }

  if ($carousel) {
    $carousel.each(function() {
      var $slides = $(this).find('.__slides');
      var $prev   = $(this).find('.--prev');
      var $next   = $(this).find('.--next');

      $slides.flickity({
        // options
        cellAlign: 'left',
        pageDots: false,
        contain: true,
        prevNextButtons: false,
        wrapAround: true,
      });

      $prev.on( 'click', function() {
        $slides.flickity('previous');
      });

      $next.on( 'click', function() {
        $slides.flickity('next');
      });

    });
  }

  if ($services) {

    $services.each(function() {
      var $items = $(this).find('.__services');

      $items.flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        // wrapAround: true,
      });

    });
  }

  if ($info) {

    $info.each(function() {
      var $items = $(this).find('.__articles');

      $items.flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        // wrapAround: true,
      });

    });
  }

  if ($coverTool) {
    var $costSelection = $('#policyCostSelection');
    var $initial_cost = $costSelection.find("input#cover1").val();
    var $price = $coverTool.find('.__price');

    $price.text('£' + $initial_cost);

    $costSelection.change(function() {
      var $policy_cost = $(this).find("input[name='cover']:checked").val();
      $costSelection.blur();

      $price.text('£' + $policy_cost);
    });
  }

  // function resizeIframe() {
  //     if ($('iframe').contents().find('html').height() > 100) {
  //         $('iframe').height(($('iframe').contents().find('html').height()) + 1000 + 'px')
  //     } else {
  //         setTimeout(function (e) {
  //             resizeIframe();
  //         }, 50);
  //     }
  // }
  // resizeIframe();

	if (isDesktop) {
		var $footerNav  = $('.__navigation details');
    var $newsletter = $('.__newsletter');
    var $menuColumn = $('.__menuColumn');

		$footerNav.each(function() {
			$(this).attr('open', true);

      $(this).find('summary').on('click', function(e) {
				e.preventDefault();
			});
		});

    $newsletter.each(function() {
			$(this).attr('open', true);

      $(this).find('summary').on('click', function(e) {
				e.preventDefault();
			});
		});

    $menuColumn.each(function() {
			$(this).attr('open', true);

      $(this).find('summary').on('click', function(e) {
				e.preventDefault();
			});
		});


	} else {
		var $footerNav  = $('.__navigation details');
    var $newsletter = $('.__newsletter');
    var $menuColumn = $('.__menuColumn');

		$footerNav.each(function() {
			$(this).removeAttr('open');
		});

    $newsletter.each(function() {
			$(this).removeAttr('open');
		});

    $menuColumn.each(function() {
			$(this).removeAttr('open');
		});
	}

});
